import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Text } from '@modusign/design-system';

import { MAX_SIGNER_COUNT } from '@app/constants/documentSetup';

interface SignerCardsSignerCountProps {
  count: number;
}
export default function SignerCardsSignerCount({ count }: SignerCardsSignerCountProps) {
  return (
    <Box backgroundColor="lightGray600" borderRadius="4px" mb={4} p={3}>
      <Text fontSize="sm" fontWeight="medium" mr={2}>
        <FontAwesomeIcon icon={faUser} style={{ marginRight: '4px' }} />
        서명 인원
      </Text>
      <Text data-testid="signer-cards-signer-count" fontSize="sm" fontWeight="medium">
        {count}
      </Text>
      <Text color="textNeutralLight" fontSize="sm" fontWeight="medium">
        /{MAX_SIGNER_COUNT}
      </Text>
    </Box>
  );
}
